import {useSelector} from "react-redux";
import Root from "../store/reducers/root/actions.js";


export default function useWindowSize() {
  return useSelector(Root.savedDimensions);
}
